// import React from 'react';
// import Footer from '../../components/Footer';
// import HospitalAdminImg from "../../assets/images/diplomao.jpeg"; // Replace with your image path
// import { Link } from 'react-router-dom';

// const HospitalAdmin = () => {
//   return (
//     <div className='w-full relative font-poppins'>
//         <div className='w-10/12 mx-auto mt-[100px] md:mt-[150px] flex flex-col gap-5 md:gap-5'>
//             <h2 className={`mb-4 text-2xl md:text-6xl tracking-tight font-bold text-center text-[#0e4d38]`}>
//                 School of Hospital Administration
//             </h2>
//             <div className='w-[20%] mx-auto h-[6px] bg-[#23376c] mt-[-10px] md:mt-[-20px]'></div>

//             <div className='flex flex-col md:flex-row gap-8 mb-10 md:gap-[80px] mt-5 justify-center md:justify-between'>
//                 <img src={HospitalAdminImg} className='md:w-[40%] rounded-lg' alt="Hospital Administration at Maya Devi University"/>
//                 <div className='flex flex-col gap-4'>
//                     <h4 className='font-bold text-xl md:text-3xl'>About the Department</h4>
//                     <p className='text-justify md:text-lg'>
//                         The School of Hospital Administration at Maya Devi University is dedicated to shaping the future of healthcare management. With a focus on leadership, strategic planning, and operational efficiency, our programs prepare students to excel in the dynamic healthcare industry. We offer specialized courses in Hospital Administration and Public Health, designed to meet the growing demand for skilled professionals in these fields.
//                         <br/><br/>
//                         Our curriculum combines theoretical knowledge with practical training, ensuring that graduates are well-equipped to handle the complexities of healthcare management. Whether you aspire to lead hospitals, improve public health systems, or work in healthcare policy, our programs provide the foundation for a successful career.
//                         <br/><br/>
//                         <strong>Benefits of Our Courses:</strong><br/>
//                         <ul className='list-disc text-[14px]'>
//                             <li>Comprehensive curriculum covering healthcare management and public health</li>
//                             <li>Hands-on training through internships and fieldwork</li>
//                             <li>Expert faculty with industry experience</li>
//                             <li>Global perspective on healthcare trends and practices</li>
//                             <li>Strong industry connections for placements</li>
//                             <li>Leadership and critical thinking skill development</li>
//                         </ul>
//                     </p>
//                     <Link to="https://admission.maya.edu.in/">
//                         <button className='mt-5 md:mt-0 bg-[#23376c] px-4 py-2 text-white rounded-full font-semibold transition-all duration-200 hover:bg-[#4865b3]'>
//                             Register Now
//                         </button>
//                     </Link>
//                 </div>
//             </div>

//             <div className='flex flex-col gap-10 mt-5 mb-[50px]'>
//                 <div className='flex flex-col gap-2'>
//                     <h4 className={`text-2xl font-semibold text-[#0e4d38]`}>Courses Offered</h4>
//                     <p>We offer a range of programs to cater to different career aspirations in healthcare management and public health:</p>
//                 </div>
//             </div>

//             {/* Course Details Table */}
//             <div className="flex flex-col">
//                 <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
//                     <div className="inline-block min-w-full py-2 sm:px-6 lg:px-8">
//                         <div className="overflow-hidden">
//                             <table className="min-w-full text-center text-sm font-light">
//                                 <thead className="border-b bg-[#23376c] font-medium text-white rounded-md">
//                                     <tr>
//                                         <th scope="col" className="px-6 py-4">Programme</th>
//                                         <th scope="col" className="px-6 py-4">Duration (Years)</th>
//                                         <th scope="col" className="px-6 py-4">No. of Seats</th>
//                                         <th scope="col" className="px-6 py-4">One time Charges including Registration</th>
//                                         <th scope="col" className="px-6 py-4">Yearly Fee (All India Quota)</th>
//                                         <th scope="col" className="px-6 py-4">Yearly Fee (UK Domicile)</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     <tr className="border-b dark:border-neutral-500">
//                                         <td className="whitespace-nowrap px-6 py-4 font-semibold">Bachelor of Hospital Administration (BHA)</td>
//                                         <td className="whitespace-nowrap px-6 py-4">3</td>
//                                         <td className="whitespace-nowrap px-6 py-4">60</td>
//                                         <td className="whitespace-nowrap px-6 py-4">Rs.21000/-</td>
//                                         <td className="whitespace-nowrap px-6 py-4">Rs.95000/-</td>
//                                         <td className="whitespace-nowrap px-6 py-4">Rs.70000/-</td>
//                                     </tr>
//                                     <tr className="border-b dark:border-neutral-500">
//                                         <td className="whitespace-nowrap px-6 py-4 font-semibold">Bachelor of Public Health (BPH)</td>
//                                         <td className="whitespace-nowrap px-6 py-4">3</td>
//                                         <td className="whitespace-nowrap px-6 py-4">40</td>
//                                         <td className="whitespace-nowrap px-6 py-4">Rs.21000/-</td>
//                                         <td className="whitespace-nowrap px-6 py-4">Rs.85000/-</td>
//                                         <td className="whitespace-nowrap px-6 py-4">Rs.60000/-</td>
//                                     </tr>
//                                     <tr className="border-b dark:border-neutral-500">
//                                         <td className="whitespace-nowrap px-6 py-4 font-semibold">Master of Hospital Administration (MHA)</td>
//                                         <td className="whitespace-nowrap px-6 py-4">2</td>
//                                         <td className="whitespace-nowrap px-6 py-4">30</td>
//                                         <td className="whitespace-nowrap px-6 py-4">Rs.21000/-</td>
//                                         <td className="whitespace-nowrap px-6 py-4">Rs.105000/-</td>
//                                         <td className="whitespace-nowrap px-6 py-4">Rs.80000/-</td>
//                                     </tr>
//                                     <tr className="border-b dark:border-neutral-500">
//                                         <td className="whitespace-nowrap px-6 py-4 font-semibold">Master of Public Health (MPH)</td>
//                                         <td className="whitespace-nowrap px-6 py-4">2</td>
//                                         <td className="whitespace-nowrap px-6 py-4">30</td>
//                                         <td className="whitespace-nowrap px-6 py-4">Rs.21000/-</td>
//                                         <td className="whitespace-nowrap px-6 py-4">Rs.95000/-</td>
//                                         <td className="whitespace-nowrap px-6 py-4">Rs.70000/-</td>
//                                     </tr>
//                                 </tbody>
//                             </table>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             {/* Hostel Fee Table */}
//             <div className="flex flex-col mt-10 mb-10">
//                 <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
//                     <div className="inline-block min-w-full py-2 sm:px-6 lg:px-8">
//                         <div className="overflow-hidden">
//                             <table className="min-w-full text-center text-sm font-light">
//                                 <thead className="border-b bg-[#23376c] font-medium text-white rounded-md">
//                                     <tr>
//                                         <th></th>
//                                         <th scope="col" className="px-6 py-4">Hostel Fee</th>
//                                         <th></th>
//                                     </tr>
//                                     <tr>
//                                         <th scope="col" className="px-6 py-4">Sr. No</th>
//                                         <th scope="col" className="px-6 py-4">Type</th>
//                                         <th scope="col" className="px-6 py-4">Fee</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     <tr className="border-b dark:border-neutral-500">
//                                         <td className="whitespace-nowrap px-6 py-4">1</td>
//                                         <td className="whitespace-nowrap px-6 py-4">Triple Sharing (Non AC)</td>
//                                         <td className="whitespace-nowrap px-6 py-4">75000/-</td>
//                                     </tr>
//                                     <tr className="border-b dark:border-neutral-500">
//                                         <td className="whitespace-nowrap px-6 py-4">2</td>
//                                         <td className="whitespace-nowrap px-6 py-4">Double Sharing (Non AC)</td>
//                                         <td className="whitespace-nowrap px-6 py-4">85000/-</td>
//                                     </tr>
//                                     <tr className="border-b dark:border-neutral-500">
//                                         <td className="whitespace-nowrap px-6 py-4">3</td>
//                                         <td className="whitespace-nowrap px-6 py-4">Triple Sharing (AC)</td>
//                                         <td className="whitespace-nowrap px-6 py-4">115000/-</td>
//                                     </tr>
//                                     <tr className="border-b dark:border-neutral-500">
//                                         <td className="whitespace-nowrap px-6 py-4">4</td>
//                                         <td className="whitespace-nowrap px-6 py-4">Double Sharing (AC)</td>
//                                         <td className="whitespace-nowrap px-6 py-4">125000/-</td>
//                                     </tr>
//                                 </tbody>
//                             </table>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//         <Footer/>
//     </div>
//   );
// };

// export default HospitalAdmin;





import React from 'react';
import { motion } from 'framer-motion';
import Footer from '../../components/Footer';
import {
    MonitorPlay,
    Building,
    Wrench,
    Rocket,
    Stars,
    Briefcase,
    GraduationCap,
    ChevronRight, BookOpen,
    Award, Users, Globe,
    Clock, Bookmark, Share2, ArrowUpRight,
    Target, // for Vision
    Flag, // for Mission
    HelpCircle, // for Why Study
    Award as UniqueIcon // for What Makes Unique

} from 'lucide-react';
import { Link } from 'react-router-dom';
import Title from '../../components/TitleComponent'


const DiplomaPrograms = [
    {
        name: "Diploma in Civil Engineering",
        path: "/programmes/ug-courses/engineering/btech/cloud-computing-engineering"
    },
    {
        name: "Diploma in Computer Science & Engineering",
        path: "/programmes/ug-courses/engineering/btech/data-science-engineering"
    },
    {
        name: "Diploma in Electronics and Communication Engineering",
        path: "/programmes/ug-courses/engineering/btech/cybersecurity-engineering"
    },
    {
        name: "Diploma in Mechanical Engineering",
        path: "/programmes/ug-courses/engineering/btech/ai-ml"
    },

]

const undergraduatePrograms = [

    {
        name: "Bachelor of Technology in Cloud Computing and Engineering",
        path: "/programmes/ug-courses/engineering/btech/cloud-computing-engineering"
    },
    {
        name: "Bachelor of Technology in Data Science and Engineering",
        path: "/programmes/ug-courses/engineering/btech/data-science-engineering"
    },
    {
        name: "Bachelor of Technology in Cyber Security and Engineering",
        path: "/programmes/ug-courses/engineering/btech/cybersecurity-engineering"
    },
    {
        name: "Bachelor of Technology in Artificial Intelligence Machine Learning and Engineering",
        path: "/programmes/ug-courses/engineering/btech/ai-ml"
    },
    {
        name: "Bachelor of Technology in Civil Engineering",
        path: "/programmes/ug-courses/engineering/btech/civil-engineering"
    },
    {
        name: "Bachelor of Technology in Computer Science and Engineering",
        path: "/programmes/ug-courses/engineering/btech/computer-science-engineering"
    },
    {
        name: "Bachelor of Technology in Mechanical Engineering",
        path: "/programmes/ug-courses/engineering/btech/mechanical-engineering"
    },
    // {
    //     name: "Bachelor of Technology in Mechatronics and Robotics",
    //     path: "/programmes/ug-courses/engineering/btech/mechatronics-and-robotics"
    // },
]

const PostgraduatePrograms = [
    {
        name: "Master of Technology in Thermal Engineering",
        path: "/programmes/pg-courses/engineering/mtech/thermal-engineering"
    },
    {
        name: "Master of Technology in Production Engineering",
        path: "/programmes/pg-courses/engineering/mtech/production-engineering"
    },
    {
        name: "Master of Technology in Renewable Energy",
        path: "/programmes/pg-courses/engineering/mtech/renewable-energy"
    },
    // {
    //     name: "Master of Technology in Electric Vehicle  Technology",
    //     path: "/programmes/pg-courses/engineering/mtech/electric-vehicle"
    // },
    {
        name: "Master of Technology in Structural Engineering",
        path: "/programmes/pg-courses/engineering/mtech/structural-engineering"
    },
    {
        name: "Master of Technology in Transportation Engineering",
        path: "/programmes/pg-courses/engineering/mtech/transportation-engineering"
    },
    // {
    //     name: "Master of Technology in Data Science and Engineering",
    //     path: "/programmes/pg-courses/engineering/mtech/data-science-engineering"
    // },
    // {
    //     name: "Master of Technology in Artificial Intelligence Machine Learning and Engineering",
    //     path: "/programmes/pg-courses/engineering/mtech/ai-ml"
    // },
    {
        name: "Master of Technology in Digital Communication Engineering",
        path: "/programmes/pg-courses/engineering/mtech/digital-communication"
    },

]

const Stats = () => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 my-4 md:my-8 px-4"
    >
        {[
            { icon: <Users className="w-6 h-6 md:w-8 md:h-8" />, number: "5000+", label: "Students Enrolled", color: "bg-blue-50" },
            { icon: <BookOpen className="w-6 h-6 md:w-8 md:h-8" />, number: "50+", label: "Programs Offered", color: "bg-green-50" },
            { icon: <Award className="w-6 h-6 md:w-8 md:h-8" />, number: "95%", label: "Placement Rate", color: "bg-purple-50" },
            { icon: <Globe className="w-6 h-6 md:w-8 md:h-8" />, number: "100+", label: "Industry Partners", color: "bg-orange-50" }
        ].map((stat, index) => (
            <motion.div
                key={index}
                className={`${stat.color} p-4 rounded-xl shadow-md hover:shadow-xl transition-all duration-300`}
                whileHover={{ scale: 1.02 }}
            >
                <div className="text-[#0e4d38]">{stat.icon}</div>
                <h3 className="text-xl md:text-2xl font-bold mt-2 text-gray-800">{stat.number}</h3>
                <p className="text-gray-600 text-xs md:text-sm">{stat.label}</p>
            </motion.div>
        ))}
    </motion.div>
);


const AboutSection = () => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="bg-white p-6 rounded-xl shadow-lg"
    >
        <div className="flex items-center gap-3 mb-4 border-b pb-4">
            <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
                <BookOpen className="w-6 h-6" />
            </div>
            <h4 className="text-xl font-semibold text-[#0e4d38]">Welcome to the School of Nursing – Maya Devi University</h4>
        </div>
        <div className="space-y-4 text-gray-700">
            <p>The School of Nursing at Maya Devi University, recognized as one of the best nursing colleges in Dehradun, is a center of excellence for nurturing compassionate and skilled healthcare professionals. With its state-of-the-art infrastructure and a curriculum designed to meet global healthcare standards, the school offers a comprehensive education in nursing through its three flagship programs: B.Sc. Nursing, General Nursing and Midwifery (GNM), and Diploma in Nursing Assistant.
            </p>
        </div>
    </motion.div>
);

const VisionMissionSection = () => (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="bg-white p-6 rounded-xl shadow-lg"
        >
            <div className="flex items-center gap-3 mb-4 border-b pb-4">
                <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
                    <Target className="w-6 h-6" />
                </div>
                <h4 className="text-xl font-semibold text-[#0e4d38]">Bachelor of Hospital Administration (BHA)</h4>
            </div>
            <div className='mb-4'>
                <p>This undergraduate course is designed to prepare students for administrative and management roles in hospitals and healthcare organizations. The curriculum covers essential topics such as healthcare systems, hospital operations, finance, and patient care management, making it a perfect stepping stone for those seeking a career in hospital management.<br />
                </p>
            </div>
            {/* <ul className="space-y-3 text-gray-700">
                <span><b>Key Features:</b></span><br />
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>Data Science – Master data analytics, machine learning, and AI-driven decision-making.</span>
                </li>
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>Cyber Security – Gain expertise in ethical hacking, digital forensics, and network security.</span>
                </li>
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>AI & Machine Learning (AIML) – Learn AI technologies, deep learning, and automation solutions.</span>
                </li>
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>Full Stack Development – Become a proficient developer with expertise in front-end and back-end technologies.</span>
                </li>
            </ul> */}
        </motion.div>

        <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="bg-white p-6 rounded-xl shadow-lg"
        >
            <div className="flex items-center gap-3 mb-4 border-b pb-4">
                <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
                    <Flag className="w-6 h-6" />
                </div>
                <h4 className="text-xl font-semibold text-[#0e4d38]">Bachelor of Public Health (BPH)</h4>
            </div>
            <div className='mb-4'>
                <p>The Bachelor of Public Health program focuses on public health policies, healthcare promotion, epidemiology, and community health. It’s an ideal course for students who are passionate about improving health outcomes at a population level and working towards a healthier society.<br />
                </p>
            </div>
            {/* <ul className="space-y-3 text-gray-700">
                <span><b>Key Features:</b></span><br />
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>Curriculum: Students learn about diagnostic imaging techniques, radiation safety, medical terminology, and patient care. The program also includes practical training in radiology labs.</span>
                </li>
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>Skills Developed: Students gain proficiency in operating imaging equipment, performing diagnostic tests, and ensuring patient safety during imaging procedures.</span>
                </li>
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>Career Opportunities: Graduates can pursue careers as radiology technicians, imaging specialists, or radiology consultants in hospitals, diagnostic centers, and imaging clinics.</span>
                </li>
            </ul> */}
        </motion.div>

        <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="bg-white p-6 rounded-xl shadow-lg"
        >
            <div className="flex items-center gap-3 mb-4 border-b pb-4">
                <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
                    <Target className="w-6 h-6" />
                </div>
                <h4 className="text-xl font-semibold text-[#0e4d38]">Master of Hospital Administration (MHA)</h4>
            </div>
            <div className='mb-4'>
                <p>For those looking to advance their career in healthcare leadership, the Master of Hospital Administration offers advanced training in healthcare management, policy analysis, strategic planning, and organizational behavior. This program is designed to provide the skills needed to excel in senior administrative positions in hospitals and healthcare systems.<br />
                </p>
            </div>
            {/* <ul className="space-y-3 text-gray-700">
                <span><b>Key Features:</b></span><br />
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>Curriculum: The program covers subjects like clinical biochemistry, microbiology, hematology, and pathology. Students will also gain experience in lab procedures, test analysis, and quality control.</span>
                </li>
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>Skills Developed: Graduates are equipped with technical skills to perform lab tests, analyze results, and provide accurate data to healthcare providers for diagnosis and treatment.</span>
                </li>
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>Career Opportunities: BMLT graduates are in high demand in hospitals, diagnostic laboratories, research centers, and healthcare facilities. They can work as medical lab technicians, lab supervisors, or quality control analysts.</span>
                </li>
            </ul> */}
        </motion.div>

        <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="bg-white p-6 rounded-xl shadow-lg"
        >
            <div className="flex items-center gap-3 mb-4 border-b pb-4">
                <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
                    <Flag className="w-6 h-6" />
                </div>
                <h4 className="text-xl font-semibold text-[#0e4d38]">Master of Public Health (MPH)</h4>

            </div>
            <div className='mb-4'>
                <p>
                    Our Master of Public Health program prepares students for high-level roles in public health agencies, non-governmental organizations, and healthcare systems. The course dives deep into global health issues, epidemiology, and health policy, ensuring that graduates are well-equipped to tackle complex public health challenges.<br />
                </p>
            </div>
            {/* <ul className="space-y-3 text-gray-700">
                <span><b>Key Features:</b></span><br />
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>Data Science – Advance your career with expertise in AI, Big Data, and predictive analytics.</span>
                </li>
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>Full Stack Development – Become an industry-ready software professional with advanced development skills.</span>
                </li>
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>Career Opportunities: Graduates can work as operation theater technicians, surgical assistants, or sterile supply coordinators in hospitals, surgical centers, and trauma care units.</span>
                </li>
            </ul> */}
        </motion.div>
    </div>
);


const ProgramSection = () => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="bg-white p-6 rounded-xl shadow-lg"
    >
        <div className="flex items-center gap-3 mb-4 border-b pb-4">
            <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
                <BookOpen className="w-6 h-6" />
            </div>
            <h4 className="text-xl font-semibold text-[#0e4d38]">Our Courses</h4>
        </div>
        <div className="space-y-4 text-gray-700">
            <p>At Maya Devi University, we offer comprehensive programs designed to equip students with the skills and knowledge required for leadership roles in healthcare settings.
            </p>

            {/* <p>The 21st century is marked by rapid innovation, and exposure to engineering allows students to stay at the forefront of modern technological trends. Engineering plays a vital role in solving real-world problems, offering practical solutions that address the needs of society. As long as humanity continues to evolve, the demand for skilled engineers remains essential.  </p>

            <p>Upon graduation, engineers have access to a broad spectrum of career opportunities, whether in traditional engineering roles or in entrepreneurial ventures, enabling them to innovate and contribute to society in multiple  ways.
            </p> */}
        </div>
    </motion.div>
);

const WhySection = () => (
    <motion.div
        initial={{ opacity: 0, x: 20 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        className="bg-white p-6 rounded-xl shadow-lg"
    >
        <div className="flex items-center gap-3 mb-4 border-b pb-4">
            <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
                <Flag className="w-6 h-6" />
            </div>
            <h4 className="text-xl font-semibold text-[#0e4d38]">Why Choose Us?</h4>
        </div>
        {/* <div className='mb-4'>
            <p> <div className='mb-4'>
                <p>The healthcare industry is rapidly expanding, making nursing one of the most rewarding and stable career choices. Nurses play a pivotal role in patient care, medical research, and community health development. Whether you aspire to work in a high-tech hospital, serve in rural healthcare, or pursue advanced specializations, nursing offers endless opportunities for growth and fulfillment.<br />
                </p>
            </div><br />
            </p>
        </div> */}
        <ul className="space-y-3 text-gray-700">
            {/* <span><b>Career Opportunities After Completing a Nursing Program:</b></span><br /> */}
            <li className="flex items-start gap-2">
                <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                <span>Top-Ranking Institution: As one of the Best Public Health Colleges in Dehradun, we are committed to offering quality education that meets international standards.</span>
            </li>
            <li className="flex items-start gap-2">
                <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                <span>State-of-the-Art Facilities: Our campus is equipped with modern classrooms, healthcare labs, and digital resources that enhance learning.</span>
            </li>
            <li className="flex items-start gap-2">
                <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                <span>Holistic Development: Along with academic excellence, we focus on developing leadership, critical thinking, and problem-solving skills that are essential for success in healthcare management.</span>
            </li>
            {/* <li className="flex items-start gap-2">
                <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                <span>Midwife</span>
            </li>
            <li className="flex items-start gap-2">
                <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                <span>Community Health Worker</span>
            </li>
            <li className="flex items-start gap-2">
                <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                <span>Nursing Assistant</span>
            </li>
            <li className="flex items-start gap-2">
                <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                <span>International Nursing Positions</span>
            </li> */}
        </ul>

        <div className='mb-4 mt-4'>
            <p> <div className='mb-4'>
                <p>If you're looking for the best education in Hospital Administration and Public Health, Maya Devi University is the right choice for you. Explore our courses today and take the first step towards a rewarding career in healthcare management and public health.<br />
                </p>
            </div><br />
            </p>
        </div>
    </motion.div>
);


const Benfits = () => (
    <motion.div
        initial={{ opacity: 0, x: 20 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        className="bg-white p-6 rounded-xl shadow-lg"
    >
        <div className="flex items-center gap-3 mb-4 border-b pb-4">
            <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
                <Flag className="w-6 h-6" />
            </div>
            <h4 className="text-xl font-semibold text-[#0e4d38]">Benefits of Our Courses</h4>
        </div>
        {/* <div className='mb-4'>
            <p> <div className='mb-4'>
                <p>The healthcare industry is rapidly expanding, making nursing one of the most rewarding and stable career choices. Nurses play a pivotal role in patient care, medical research, and community health development. Whether you aspire to work in a high-tech hospital, serve in rural healthcare, or pursue advanced specializations, nursing offers endless opportunities for growth and fulfillment.<br />
                </p>
            </div><br />
            </p>
        </div> */}
        <ul className="space-y-3 text-gray-700">
            {/* <span><b>Career Opportunities After Completing a Nursing Program:</b></span><br /> */}
            <li className="flex items-start gap-2">
                <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                <span>Expert Faculty: Learn from experienced professionals who bring real-world insights into the classroom.</span>
            </li>
            <li className="flex items-start gap-2">
                <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                <span>Comprehensive Curriculum: Our courses are designed to equip you with theoretical knowledge and practical skills that are crucial for success in the healthcare industry.</span>
            </li>
            <li className="flex items-start gap-2">
                <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                <span>Hands-on Training: Gain practical exposure through internships, case studies, and fieldwork opportunities.</span>
            </li>
            <li className="flex items-start gap-2">
                <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                <span>Global Perspective: Study global health trends, practices, and policies to understand how healthcare management operates on an international scale.</span>
            </li>
            {/* <li className="flex items-start gap-2">
                <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                <span>Midwife</span>
            </li>
            <li className="flex items-start gap-2">
                <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                <span>Community Health Worker</span>
            </li>
            <li className="flex items-start gap-2">
                <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                <span>Nursing Assistant</span>
            </li>
            <li className="flex items-start gap-2">
                <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                <span>International Nursing Positions</span>
            </li> */}
        </ul>

        <div className='mb-4 mt-4'>
            <p> <div className='mb-4'>
                <p>If you're looking for the best education in Hospital Administration and Public Health, Maya Devi University is the right choice for you. Explore our courses today and take the first step towards a rewarding career in healthcare management and public health.<br />
                </p>
            </div><br />
            </p>
        </div>
    </motion.div>
);


const Importance = () => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="bg-white p-6 rounded-xl shadow-lg"
    >
        <div className="flex items-center gap-3 mb-4 border-b pb-4">
            <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
                <BookOpen className="w-6 h-6" />
            </div>
            <h4 className="text-xl font-semibold text-[#0e4d38]">The Importance of Studying Hospital Administration and Public Health</h4>
        </div>
        <div className="space-y-4 text-gray-700">
            <p>AHealthcare management and public health are critical sectors that play a vital role in shaping the efficiency and quality of health systems worldwide. With an increasing demand for skilled professionals, pursuing a degree in Hospital Administration or Public Health can lead to fulfilling careers in healthcare institutions, government agencies, non-profit organizations, and international health agencies.
            </p>

            <p>Hospital administrators play a key role in ensuring hospitals run efficiently, from managing finances and staffing to overseeing patient care. Public health experts are integral to improving health policies and strategies to address public health issues such as disease prevention, healthcare access, and health promotion.</p>

            {/* <p>Upon graduation, engineers have access to a broad spectrum of career opportunities, whether in traditional engineering roles or in entrepreneurial ventures, enabling them to innovate and contribute to society in multiple  ways.
            </p> */}
        </div>
    </motion.div>
);

const Placement = () => (
    <motion.div
        initial={{ opacity: 0, x: 20 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        className="bg-white p-6 rounded-xl shadow-lg"
    >
        <div className="flex items-center gap-3 mb-4 border-b pb-4">
            <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
                <Flag className="w-6 h-6" />
            </div>
            <h4 className="text-xl font-semibold text-[#0e4d38]">Placement Opportunities</h4>
        </div>
        <div className='mb-4'>
            <p> <div className='mb-4'>
                Maya Devi University has a strong placement record, connecting students with leading healthcare organizations and institutions. As one of the Best Hospital Administration Colleges in Uttarakhand, we offer:<br />

            </div><br />
            </p>
        </div>
        <ul className="space-y-3 text-gray-700">
            {/* <span><b>Career Opportunities After Completing a Nursing Program:</b></span><br /> */}
            <li className="flex items-start gap-2">
                <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                <span>Expert Faculty: Learn from experienced professionals who bring real-world insights into the classroom.</span>
            </li>
            <li className="flex items-start gap-2">
                <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                <span>Internship Opportunities: Gain valuable industry experience with renowned healthcare institutions.</span>
            </li>
            <li className="flex items-start gap-2">
                <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                <span>Recruitment Drives: We regularly organize campus recruitment drives with top hospital chains, public health agencies, and health-focused organizations.</span>
            </li>
            <li className="flex items-start gap-2">
                <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                <span>Alumni Network: Our extensive alumni network in the healthcare industry provides mentorship and career advancement opportunities.</span>
            </li>
            {/* <li className="flex items-start gap-2">
                <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                <span>Midwife</span>
            </li>
            <li className="flex items-start gap-2">
                <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                <span>Community Health Worker</span>
            </li>
            <li className="flex items-start gap-2">
                <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                <span>Nursing Assistant</span>
            </li>
            <li className="flex items-start gap-2">
                <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                <span>International Nursing Positions</span>
            </li> */}
        </ul>

        {/* <div className='mb-4 mt-4'>
            <p> <div className='mb-4'>
                <p>If you're looking for the best education in Hospital Administration and Public Health, Maya Devi University is the right choice for you. Explore our courses today and take the first step towards a rewarding career in healthcare management and public health.<br />
                </p>
            </div><br />
            </p>
        </div> */}
    </motion.div>
);

const CourseCard = ({ course, index }) => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ delay: index * 0.1 }}
        className="group w-full"
    >
        <Link to={course.path}>
            <div className="bg-white p-3 md:p-4 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 h-full flex flex-col justify-between gap-2 md:gap-3">
                <div>
                    <div className="flex justify-between items-start">
                        <div className="p-2 bg-blue-50 rounded-lg">
                            <GraduationCap className="w-4 h-4 md:w-5 md:h-5 text-blue-600" />
                        </div>
                        <motion.div
                            whileHover={{ scale: 1.1 }}
                            className="p-1 md:p-2 rounded-full hover:bg-gray-100"
                        >
                            <ArrowUpRight className="w-3 h-3 md:w-4 md:h-4 text-gray-400 group-hover:text-[#0e4d38]" />
                        </motion.div>
                    </div>
                    <h3 className="text-sm md:text-lg font-semibold mt-2 md:mt-3 text-gray-800 group-hover:text-[#0e4d38] transition-colors line-clamp-2">
                        {course.name}
                    </h3>
                </div>
                <div className="flex items-center gap-2 md:gap-3 text-xs text-gray-500">
                    <div className="flex items-center gap-1">
                        <Clock className="w-3 h-3" />
                        <span>{course.name.includes('Master') ? '2 Years' : '4 Years'}</span>
                    </div>
                    <div className="flex items-center gap-1">
                        <Bookmark className="w-3 h-3" />
                        <span>{course.name.includes('Master') ? 'PG' : 'UG'}</span>
                    </div>
                </div>
            </div>
        </Link>
    </motion.div>
);

const Department = ({ title, icon, courses }) => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="bg-white p-4 md:p-6 rounded-xl shadow-lg"
    >
        <div className="flex items-center gap-2 md:gap-3 mb-4 md:mb-6 border-b pb-4">
            <div className="p-2 md:p-3 bg-[#0e4d38] rounded-lg text-white">
                {icon}
            </div>
            <h4 className="text-lg md:text-xl font-semibold text-[#0e4d38]">{title}</h4>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 md:gap-4">
            {courses.map((course, index) => (
                <CourseCard key={index} course={course} index={index} />
            ))}
        </div>
    </motion.div>
);

const FeatureList = ({ title, items, icon }) => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="bg-white p-4 md:p-6 rounded-xl shadow-lg"
    >
        <div className="flex items-center gap-2 md:gap-3 mb-4 md:mb-6 border-b pb-4">
            <div className="p-2 md:p-3 bg-[#0e4d38] rounded-xl text-white">
                {icon}
            </div>
            <h4 className="text-lg md:text-xl font-semibold text-[#0e4d38]">{title}</h4>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 md:gap-4">
            {items.map((item, index) => (
                <motion.div
                    key={index}
                    className="p-3 rounded-lg bg-gray-50 hover:bg-gray-100 transition-colors duration-300"
                    whileHover={{ scale: 1.02 }}
                >
                    <div className="flex items-start gap-2">
                        <div className="w-2 h-2 mt-1.5 bg-[#23376c] rounded-full flex-shrink-0" />
                        <span className="text-gray-700 text-xs md:text-sm">{item}</span>
                    </div>
                </motion.div>
            ))}
        </div>
    </motion.div>
);

const HeroSection = () => (
    <div className="relative overflow-hidden bg-[#0e4d38] text-white py-8 md:py-16 px-4 md:px-6 rounded-xl mb-6 md:mb-8 mt-16 md:mt-20">
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="max-w-5xl"
        >
            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-3 md:mb-4">
                School of Hospital Administration – Maya Devi University
            </h1>
            <p className="text-sm md:text-lg text-gray-200 mb-4 md:mb-6 max-w-3xl">
                If you're aspiring to shape the future of healthcare management, the School of Hospital Administration at Maya Devi University offers a range of specialized courses that cater to the growing demand for professionals in hospital and public health sectors. Located in Dehradun, Uttarakhand, our institution stands among the Best Hospital Administration Colleges in Dehradun and Best Hospital Administration Colleges in Uttarakhand, providing students with a top-tier education and career opportunities in the healthcare industry.

            </p>
            <Link to="https://admission.maya.edu.in/">
                <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    className="bg-white text-[#0e4d38] px-4 md:px-6 py-2 md:py-3 rounded-full text-sm md:text-base font-semibold flex items-center gap-2 group"
                >
                    Apply Now
                    <Rocket className="w-3 h-3 md:w-4 md:h-4 group-hover:translate-x-1 transition-transform" />
                </motion.button>
            </Link>
        </motion.div>
    </div>
);

const HospitalAdmin = () => {
    return (
        <div className="min-h-screen bg-gray-50 font-poppins">
            <Title title="Best School of Hospital Administration in Uttarakhand" description="Welcome to Maya Devi University, the best university in Dehradun offering top education programs." />
            <div className="max-w-7xl mx-auto pt-16 md:pt-20 pb-8 md:pb-16 px-4 space-y-6 md:space-y-8">
                <HeroSection />
                <Stats />
                <AboutSection />
                <WhySection />
                <ProgramSection />
                {/* <WhatSection /> */}
                <VisionMissionSection />
                <Benfits />
                <Importance />
                <Placement />
                <div className="space-y-6 md:space-y-8">
                    {/* <Department
                        title="Diploma Programs"
                        icon={<MonitorPlay className="w-5 h-5 md:w-6 md:h-6" />}
                        courses={DiplomaPrograms}
                    /> */}
                    {/* <Department
                        title="Undergraduate Programs"
                        icon={<Building className="w-5 h-5 md:w-6 md:h-6" />}
                        courses={undergraduatePrograms}
                    />
                    <Department
                        title="Postgraduate Programs"
                        icon={<Wrench className="w-5 h-5 md:w-6 md:h-6" />}
                        courses={PostgraduatePrograms}
                    /> */}
                </div>

                {/* <div className="space-y-6 md:space-y-8">
                    <FeatureList
                        title="USPs"
                        icon={<Stars className="w-6 h-6 text-[#0e4d38]" />}
                        items={[
                            "Industry-Relevant Curriculum designed by Core Academia & Renowned Industry Experts",
                            "Renowned Domain Specific & Highly Rich Experienced Faculty",
                            "State-of-the-art infrastructure including computer labs",
                            "Centre of Excellence in Specific Domain & Technology",
                            "Continuous learning and skill enhancement",
                            "Hands-On Learning through practical projects",
                            "Live Industry Projects based Learning",
                            "Global Recognition and accreditation",
                            "LMS based Pedagogy",
                            "Choice Based Credit System (CBCS)",
                            "Industry Collaborations and Internships",
                            "Full-Time Industrial Internship",
                            "Entrepreneurship programs and incubation centres"
                        ]}
                    />

                    <FeatureList
                        title="Career Options"
                        icon={<Briefcase className="w-6 h-6 text-[#0e4d38]" />}
                        items={[
                            "Cloud Computing Specialist",
                            "Data Scientist/Data Analyst",
                            "AI/ML Engineer",
                            "Cybersecurity Analyst",
                            "Software Developer",
                            "Database Administrator",
                            "Network Engineer",
                            "IT Consultant",
                            "Systems Analyst",
                            "Web Developer",
                            "Software Engineer"
                        ]}
                    />
                </div> */}
            </div>
            <Footer />
        </div>
    );
};

export default HospitalAdmin;